export default "__VITE_ASSET__rCUXRPXg__"